import React, { useCallback, useEffect, useState } from 'react';
import { Box, Flex, useDisclosure } from '@chakra-ui/react';
import { ConfirmationDialog } from '../components/organisms/ConfirmationDialog';
import { TrainGroupsBrowseWindow } from '../components/organisms/Maintenance/BrowseWindow/TrainGroupsBrowseWindow';
import TrainGroupsCreateWindow from '../components/organisms/Maintenance/CreateWindow/TrainGroupsCreateWindow';
import TrainGroupsEditWindow from '../components/organisms/Maintenance/EditWindow/TrainGroupsEditWindow';
import {
  MaintenanceHeader,
  selectTabEnum
} from '../components/organisms/Maintenance/MaintenanceHeader';
import { MaintenanceTitle } from '../components/organisms/Maintenance/MaintenanceTitle';
import TrainGroupsSearchBox from '../components/organisms/Maintenance/SearchWindow/TrainGroupsSearchBox';
import {
  TrainGroupsType,
  MaintenanceTrainGroupsTable
} from '../components/organisms/Maintenance/Table/MaintenanceTrainGroupsTable';
import { DeleteTrainGroupsApi } from '../apis/DeleteMaintenance.api';
import { GetTrainGroupsApi } from '../apis/GetMaintenance.api';
import { chooseDataStateType } from '../components/molecules/MaintenanceModalDispLabels';

export type TrainGroupsStateType = {
  type: 'trainGroups';
  trainGroups: TrainGroupsType;
};

export type TrainGroupsArrayStateType = {
  type: 'trainGroups';
  trainGroups: TrainGroupsType[] | undefined;
};

export interface TrainGroupsSearchCondition {
  sort: { key: string; sortType: boolean };
  model: string;
  dateCreatedFrom: string;
  dateCreatedTo: string;
  dateUpdatedFrom: string;
  dateUpdatedTo: string;
}

export const TrainGroupsMaintenance: React.FC = () => {
  const [query, setQuery] = useState<TrainGroupsSearchCondition>({
    sort: { key: '', sortType: false },
    model: '',
    dateCreatedFrom: '',
    dateCreatedTo: '',
    dateUpdatedFrom: '',
    dateUpdatedTo: ''
  });

  const [createOrUpdate, setCreateOrUpdate] = useState(false);

  const CreateOrUpdateStateSwitch = useCallback(() => {
    setQuery({
      sort: { key: '', sortType: false },
      model: '',
      dateCreatedFrom: '',
      dateCreatedTo: '',
      dateUpdatedFrom: '',
      dateUpdatedTo: ''
    });
    setCreateOrUpdate(!createOrUpdate);
  }, [createOrUpdate]);

  const [searchSwitch, setSearchSwitch] = useState(false);

  const SearchStateSwitch = useCallback(() => {
    setSearchSwitch(!searchSwitch);
  }, [searchSwitch]);

  const stateUpdate = (data: chooseDataStateType) => {
    if (data.type === 'trainGroups') {
      setChooseData(data.trainGroups);
    }
  };
  const DeleteApi = async () => {
    if (chooseData?.id !== undefined) {
      const response = await DeleteTrainGroupsApi(chooseData.id);
      if (response.success) {
        setMaintenanceDatas(response.data as TrainGroupsType[]);
        CreateOrUpdateStateSwitch();
      }
    }
  };
  const {
    isOpen: isOpenCreate,
    onOpen: onOpenCreate,
    onClose: onCloseCreate
  } = useDisclosure();
  const {
    isOpen: isOpenBrowse,
    onOpen: onOpenBrowse,
    onClose: onCloseBrowse
  } = useDisclosure();
  const {
    isOpen: isOpenEdit,
    onOpen: onOpenEdit,
    onClose: onCloseEdit
  } = useDisclosure();
  const {
    isOpen: isOpenConfirm,
    onOpen: onToggle,
    onClose: onCloseConfirm
  } = useDisclosure();
  const [chooseData, setChooseData] = useState<TrainGroupsType>();
  const [maintenanceDatas, setMaintenanceDatas] = useState<
    TrainGroupsType[] | undefined | null
  >();

  const GetApi = async () => {
    const response = await GetTrainGroupsApi();
    if (response.success) {
      setMaintenanceDatas(response.data);
    }
  };

  useEffect(() => {
    GetApi();
  }, []);

  return (
    <>
      <Flex direction='column' h='100vh'>
        <MaintenanceHeader selectTab={selectTabEnum.TrainGroups} />
        <MaintenanceTitle
          selectTab={selectTabEnum.TrainGroups}
          onOpen={onOpenCreate}
        />
        <Box
          position='relative'
          display='grid'
          gridTemplateRows='0.1fr 2fr 0.1fr'
          gridTemplateColumns='3fr 1fr'
          h='100%'
        >
          <MaintenanceTrainGroupsTable
            TrainGroupsDatas={maintenanceDatas}
            setMaintenanceDatas={setMaintenanceDatas}
            setChooseData={stateUpdate}
            onOpenBrowse={onOpenBrowse}
            onOpenEdit={onOpenEdit}
            onToggle={onToggle}
            Query={query}
            setQuery={setQuery}
            createOrUpdate={createOrUpdate}
            searchSwitch={searchSwitch}
          />

          <TrainGroupsSearchBox
            setMaintenanceDatas={setMaintenanceDatas}
            Query={query}
            setQuery={setQuery}
            createOrUpdate={createOrUpdate}
            SearchStateSwitch={SearchStateSwitch}
          />

          {isOpenCreate && (
            <TrainGroupsCreateWindow
              isOpen={isOpenCreate}
              onClose={onCloseCreate}
              setMaintenanceDatas={setMaintenanceDatas}
              CreateOrUpdateStateSwitch={CreateOrUpdateStateSwitch}
            />
          )}
          {isOpenBrowse && (
            <TrainGroupsBrowseWindow
              isOpen={isOpenBrowse}
              onClose={onCloseBrowse}
              BrowseData={chooseData}
            />
          )}

          {isOpenEdit && (
            <TrainGroupsEditWindow
              isOpen={isOpenEdit}
              onClose={onCloseEdit}
              EditData={chooseData}
              setMaintenanceDatas={setMaintenanceDatas}
              CreateOrUpdateStateSwitch={CreateOrUpdateStateSwitch}
            />
          )}
          {isOpenConfirm && (
            <ConfirmationDialog
              isOpen={isOpenConfirm}
              onClose={onCloseConfirm}
              dispMessage={'本当に削除しますか？'}
              DeleteApi={DeleteApi}
            />
          )}
        </Box>
      </Flex>
    </>
  );
};
